import { render, staticRenderFns } from "./kvkk-file-manager-view.vue?vue&type=template&id=2026d53b&scoped=true"
import script from "./kvkk-file-manager-view.vue?vue&type=script&lang=js"
export * from "./kvkk-file-manager-view.vue?vue&type=script&lang=js"
import style0 from "./kvkk-file-manager-view.vue?vue&type=style&index=0&id=2026d53b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2026d53b",
  null
  
)

export default component.exports